<template>
  <div>
    <Breadcrumbs main="Турниры" :title="isEdit ? 'Редактировать шаблон' : 'Создать шаблон'"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>{{ isEdit ? 'Редактирование шаблона' : 'Создание шаблона' }}</h5>
            </div>
            <div class="card-body">
              <div v-if="isPageLoading" class="text-center py-5">
                <b-spinner variant="primary"></b-spinner>
              </div>
              <b-card v-else>
                <!-- Название шаблона -->
                <div class="mb-3">
                  <label class="font-weight-bold star">Название шаблона</label>
                  <b-form-input v-model="templateName" placeholder="Например: PUBG Mobile Standard"></b-form-input>
                </div>
                <hr>
                <b-tabs>
                  <b-tab title="Основные" active>
                    <template #title>
                      <span class="fa fa-home mr-2"></span>
                      <span>Основные</span>
                    </template>
                    <b-form>
                      <div class="mt-3">
                        <b-form-checkbox v-model="formData.hash">Показывать только по ссылке</b-form-checkbox>
                      </div>
                      <div class="mt-3">
                        <b-form-checkbox v-model="formData.with_comments">Включить чат флудилку</b-form-checkbox>
                      </div>
                      <div class="mt-3">
                        <b-form-checkbox v-model="formData.with_cap_chats">Включить кэп-чат</b-form-checkbox>
                      </div>

                      <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
                        <b-tab v-for="lang in languages"
                               :title="lang.language"
                               :key="'lang-' + lang.id"
                               @click="getLanguageFromBtn(lang.language.toLowerCase())"
                               nav-class="mr-2 mb-2">
                          <template #title>
                            <div class="d-flex justify-content-center">
                              <img :src="lang.img" width="20" height="20" class="mr-2">
                              <span>{{ lang.language }}</span>
                            </div>
                          </template>
                        </b-tab>
                      </b-tabs>

                      <div class="mt-3">
                        <label class="font-weight-bold">Название турнира {{ language }}</label>
                        <b-form-input v-model="formData.name" placeholder="Название турнира"></b-form-input>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Дисциплина</label>
                        <b-form-select :options="games" v-model="formData.game_id" @change="handleGameChange"></b-form-select>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Тип турнира</label>
                        <b-form-select :options="variations" v-model="formData.variation_id"></b-form-select>
                      </div>

                      <div v-if="formData.variation_id === 4" class="mt-3">
                        <label class="font-weight-bold">Сезон BPL</label>
                        <b-form-select :options="bplSeasons" v-model="formData.bpl_season_id"></b-form-select>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Организатор турнира</label>
                        <b-form-select :options="organizers" v-model="formData.organizer_id"></b-form-select>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Призовой фонд</label>
                        <b-form-input type="text" v-model="formData.prize_fond"></b-form-input>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Кол-во команд</label>
                        <b-form-input type="number" v-model="formData.slot_count"></b-form-input>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Формат</label>
                        <b-form-select :options="formats" v-model="formData.format_id"></b-form-select>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Выбор страны</label>
                        <b-form-select :options="countries" v-model="formData.country_id"></b-form-select>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Подача для Tier</label>
                        <Multiselect :options="divisions" v-model="selectedDivision" label="text" track-by="value"
                                     :multiple="true" :hide-selected="true"></Multiselect>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Ссылка трансляции</label>
                        <b-form-input type="text" v-model="formData.youtube_link"></b-form-input>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Feature</label>
                        <Multiselect :options="featuresList" v-model="selectedFeature" label="text" track-by="value"
                                     :multiple="true" :hide-selected="true"></Multiselect>
                      </div>

                      <div class="mt-3">
                        <label class="font-weight-bold">Рейтинг</label>
                        <b-form-input type="number" step="0.1" v-model="formData.rating"></b-form-input>
                      </div>
                    </b-form>
                  </b-tab>

                  <b-tab title="Выбор времени">
                    <template #title>
                      <span class="fa fa-globe mr-2"></span>
                      <span>Выбор времени</span>
                    </template>
                    <b-form>
                      <div class="mt-5">
                        <label class="font-weight-bold">Часовой пояс</label>
                        <b-form-select :options="timezones" v-model="formData.timezone"></b-form-select>
                      </div>
                    </b-form>
                  </b-tab>

                  <b-tab title="Описание">
                    <template #title>
                      <span class="fa fa-list-alt mr-2"></span>
                      <span>Описание</span>
                    </template>
                    <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
                      <b-tab v-for="lang in languages"
                             :title="lang.language"
                             :key="'lang-desc-' + lang.id"
                             @click="getLanguageFromBtn(lang.language.toLowerCase())"
                             nav-class="mr-2 mb-2">
                        <template #title>
                          <div class="d-flex justify-content-center">
                            <img :src="lang.img" width="20" height="20" class="mr-2">
                            <span>{{ lang.language }}</span>
                          </div>
                        </template>
                      </b-tab>
                    </b-tabs>
                    <div class="mt-5">
                      <label class="font-weight-bold">Расписание {{ language.toUpperCase() }}</label>
                      <template v-for="lang in Object.keys(formData.schedule)">
                        <SunEditor :key="lang + '-schedule'"
                                   v-if="language === lang"
                                   v-model="formData.schedule[lang]"
                                   :editorId="'tpl-schedule'"
                        />
                      </template>
                    </div>
                    <div class="mt-2">
                      <label class="font-weight-bold">Описание {{ language.toUpperCase() }}</label>
                      <template v-for="lang in Object.keys(formData.description)">
                        <SunEditor :key="lang + '-description'"
                                   v-if="language === lang"
                                   v-model="formData.description[lang]"
                                   :editorId="'tpl-description'"
                        />
                      </template>
                    </div>
                    <div class="mt-2">
                      <label class="font-weight-bold">Правила {{ language.toUpperCase() }}</label>
                      <template v-for="lang in Object.keys(formData.rules)">
                        <SunEditor :key="lang + '-rules'"
                                   v-if="language === lang"
                                   v-model="formData.rules[lang]"
                                   :editorId="'tpl-rules'"
                        />
                      </template>
                    </div>
                  </b-tab>

                  <b-tab title="Очки за place">
                    <template #title>
                      <span class="fa fa-database mr-2"></span>
                      <span>Очки за place</span>
                    </template>
                    <div class="mt-4">
                      <div v-for="(item, idx) in placePoints" :key="'placePts_' + idx">
                        <div class="d-flex flex-wrap">
                          <div class="mr-2">
                            <label>Место</label>
                            <b-form-input :value="item.place" disabled></b-form-input>
                          </div>
                          <div class="mr-2">
                            <label>Очки</label>
                            <b-form-input :value="item.place_pts"
                                          @change="changePlacePoints(idx, $event)"
                                          placeholder="Введите количество очков"></b-form-input>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-center flex-wrap">
                        <button class="btn btn-success mt-4" @click="addPlace">Добавить место</button>
                        <button class="btn btn-danger mt-4 ml-2" @click="deletePlace">Удалить место</button>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab title="Призы за place">
                    <template #title>
                      <span class="fa fa-database mr-2"></span>
                      <span>Призы за place</span>
                    </template>
                    <div class="mt-4">
                      <div v-for="(item, idx) in prizeFund" :key="'prizePts_' + idx">
                        <div class="d-flex flex-wrap">
                          <div class="mr-2">
                            <label>Место</label>
                            <b-form-input :value="item.place" disabled></b-form-input>
                          </div>
                          <div class="mr-2">
                            <label>Приз</label>
                            <b-form-input :value="item.prize_data.amount"
                                          @change="changePrizeAmount(idx, $event)"
                                          placeholder="Введите количество очков"></b-form-input>
                          </div>
                          <div class="mr-2">
                            <label>Валюта</label>
                            <b-form-select :value="item.prize_data.type"
                                           @change="changePrizeType(idx, $event)"
                                           :options="prizeTypes"></b-form-select>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-center flex-wrap">
                        <button class="btn btn-success mt-4" @click="addPrize">Добавить приз</button>
                        <button class="btn btn-danger mt-4 ml-2" @click="deletePrize">Удалить приз</button>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab title="Мета данные">
                    <template #title>
                      <span class="fa fa-database mr-2"></span>
                      <span>Мета данные</span>
                    </template>
                    <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
                      <b-tab v-for="lang in languages"
                             :title="lang.language"
                             :key="'lang-meta-' + lang.id"
                             @click="getLanguageFromBtn(lang.language.toLowerCase())"
                             nav-class="mr-2 mb-2">
                        <template #title>
                          <div class="d-flex justify-content-center">
                            <img :src="lang.img" width="20" height="20" class="mr-2">
                            <span>{{ lang.language }}</span>
                          </div>
                        </template>
                      </b-tab>
                    </b-tabs>
                    <div class="mt-5">
                      <div>
                        <label class="font-weight-bold">Мета заголовок {{ language }}</label>
                        <b-form-input v-model="formData.meta_title[language]" placeholder="Название"></b-form-input>
                      </div>
                      <div class="mt-2">
                        <label class="font-weight-bold">Мета описание {{ language }}</label>
                        <b-textarea v-model="formData.meta_description[language]" class="h-30"></b-textarea>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>

                <div class="mt-3">
                  <b-btn variant="success" @click="saveTemplate" :disabled="isSaving">
                    <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>
                    {{ isEdit ? 'Сохранить' : 'Создать' }}
                  </b-btn>
                  <b-btn variant="secondary" class="ml-2" @click="$router.push({ name: 'templates_list' })">Отмена</b-btn>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";
import {LanguageAdapterMixin} from "@/mixins/Language/LanguageAdapterMixin";
import {mapActions, mapGetters, mapMutations} from "vuex";
import * as mutypes from "@/store/mutation.types";
import Multiselect from "vue-multiselect";
import SunEditor from "@/components/SunEditor.vue";

const emptyLangObj = () => ({ ru: '', en: '', uz: '', kk: '' })

export default {
  name: "TemplateForm",
  mixins: [LanguageAdapterMixin],
  components: { Multiselect, SunEditor },
  data() {
    return {
      templateName: '',
      formData: {
        type: 0,
        game_id: null,
        organizer_id: null,
        country_id: null,
        format_id: null,
        variation_id: null,
        name: '',
        slot_count: null,
        prize_fond: '',
        youtube_link: '',
        timezone: null,
        with_comments: false,
        with_cap_chats: false,
        hash: false,
        rating: null,
        bpl_season_id: null,
        description: emptyLangObj(),
        schedule: emptyLangObj(),
        rules: emptyLangObj(),
        meta_title: emptyLangObj(),
        meta_description: emptyLangObj(),
      },
      selectedFeature: [],
      selectedDivision: [],
      placePoints: [],
      prizeFund: [],
      prizeTypes: [
        { value: 'dollars', text: '$' },
        { value: 'uc', text: 'UC' },
      ],
      bplSeasons: [],
      isPageLoading: false,
      isSaving: false,
    }
  },
  computed: {
    ...mapGetters({
      _games: 'getTournamentGames',
      _organizers: 'getTournamentOrganizers',
      _formats: 'getTournamentsFormats',
      _timezones: 'getTimezones',
      _countries: 'getCountries',
      _variations: 'getTournamentVariations',
      _divisions: 'getTournamentDivisions',
      _featuresList: 'getFeaturesList',
    }),
    games() { return this._games || [] },
    organizers() { return this._organizers || [] },
    formats() { return this._formats || [] },
    timezones() { return this._timezones || [] },
    countries() { return this._countries || [] },
    variations() { return this._variations || [] },
    divisions() { return this._divisions || [] },
    featuresList() { return this._featuresList || [] },
    isEdit() {
      return !!this.$route.params.id
    },
  },
  async mounted() {
    this.isPageLoading = true
    try {
      await Promise.allSettled([
        this.grabGames(),
        this.grabOrganizers(),
        this.indexTimeZones(),
        this.getCountriesQuery(),
        this.grabFeaturesList(),
        this.grabVariations(),
        this.loadBplSeasons(),
      ])
      if (this.isEdit) {
        await this.loadTemplate()
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.isPageLoading = false
    }
  },
  methods: {
    ...mapActions([
      'grabGames',
      'grabOrganizers',
      'indexFormat',
      'indexTimeZones',
      'getCountriesQuery',
      'grabDivisionsList',
      'grabVariations',
      'getBplSeasons',
      'grabFeaturesList',
    ]),

    async loadBplSeasons() {
      try {
        const res = await this.getBplSeasons()
        this.bplSeasons = (res.data?.data || []).map(s => ({ value: s.id, text: s.name }))
      } catch (e) {
        this.bplSeasons = []
      }
    },

    async loadTemplate() {
      try {
        const res = await api.tournamentTemplate.show(this.$route.params.id)
        // Поддержка обоих форматов: { data: { id, name, data } } и { id, name, data }
        const responseData = res.data
        const tpl = responseData?.data?.id !== undefined ? responseData.data : responseData
        this.templateName = tpl.name
        const rawData = tpl.data || {}
        const d = typeof rawData === 'string' ? JSON.parse(rawData) : rawData

        // Скалярные поля
        const scalars = ['type', 'game_id', 'organizer_id', 'country_id', 'format_id', 'variation_id',
          'name', 'slot_count', 'prize_fond', 'youtube_link', 'timezone', 'with_comments',
          'with_cap_chats', 'hash', 'rating', 'bpl_season_id']
        scalars.forEach(key => {
          if (d[key] !== undefined) this.formData[key] = d[key]
        })

        // Языковые объекты
        ;['description', 'schedule', 'rules', 'meta_title', 'meta_description'].forEach(key => {
          if (d[key]) this.formData[key] = { ...emptyLangObj(), ...d[key] }
        })

        // Массивы
        if (d.features_ids && this.featuresList) {
          this.selectedFeature = this.featuresList.filter(f => d.features_ids.includes(f.value))
        }
        if (d.divisions && this.divisions) {
          this.selectedDivision = this.divisions.filter(div => d.divisions.includes(div.value))
        }

        // Place points
        if (d.tournament_place_points) {
          try {
            this.placePoints = typeof d.tournament_place_points === 'string'
                ? JSON.parse(d.tournament_place_points)
                : d.tournament_place_points
          } catch (e) {
            this.placePoints = []
          }
        }

        // Prize fund
        if (d.prize_fund) {
          this.prizeFund = d.prize_fund.map(p => ({
            place: p.place,
            prize_data: { type: p.prize_data?.type || 'dollars', amount: p.prize_data?.amount || 0 }
          }))
        }

        // Подгрузим форматы и дивизионы по game_id
        if (d.game_id) {
          await this.handleGameChange()
          // Восстановим selectedDivision после загрузки дивизионов
          if (d.divisions && this.divisions) {
            this.selectedDivision = this.divisions.filter(div => d.divisions.includes(div.value))
          }
        }
      } catch (e) {
        this.showToast('Не удалось загрузить шаблон', 'error')
        console.error(e)
      }
    },

    async handleGameChange() {
      if (!this.formData.game_id) return
      this.selectedDivision = []
      await Promise.all([
        this.indexFormat({ gameId: this.formData.game_id }),
        this.grabDivisionsList({
          ...(this.formData.game_id === 1 && { slug: 'pubg-mobile' }),
          ...(this.formData.game_id === 3 && { slug: 'mlbb' }),
        }),
      ])
    },

    buildTemplateData() {
      const data = { ...this.formData }

      // Features
      if (this.selectedFeature.length) {
        data.features_ids = this.selectedFeature.map(f => f.value)
      }

      // Divisions
      if (this.selectedDivision.length) {
        data.divisions = this.selectedDivision.map(d => d.value)
      }

      // Place points
      if (this.placePoints.length) {
        data.tournament_place_points = JSON.stringify(this.placePoints)
      }

      // Prize fund
      if (this.prizeFund.length) {
        data.prize_fund = this.prizeFund
      }

      // Удалим пустые значения (скаляры)
      Object.keys(data).forEach(key => {
        const val = data[key]
        if (val === null || val === '' || val === undefined) {
          delete data[key]
          return
        }
        // Удалим языковые объекты если все значения пустые
        if (typeof val === 'object' && !Array.isArray(val) && val !== null) {
          const allEmpty = Object.values(val).every(v => v === '' || v === null || v === undefined)
          if (allEmpty) {
            delete data[key]
          }
        }
      })

      return data
    },

    async saveTemplate() {
      if (!this.templateName.trim()) {
        this.showToast('Введите название шаблона', 'error')
        return
      }

      this.isSaving = true
      const payload = {
        name: this.templateName,
        data: this.buildTemplateData(),
      }

      try {
        if (this.isEdit) {
          await api.tournamentTemplate.update(this.$route.params.id, payload)
          this.showToast('Шаблон обновлён')
        } else {
          await api.tournamentTemplate.store(payload)
          this.showToast('Шаблон создан')
        }
        this.$router.push({ name: 'templates_list' })
      } catch (e) {
        this.showToast('Не удалось сохранить шаблон', 'error')
        console.error(e)
      } finally {
        this.isSaving = false
      }
    },

    addPlace() {
      this.placePoints.push({ place: this.placePoints.length, place_pts: 0 })
    },

    deletePlace() {
      if (this.placePoints.length > 0) {
        this.placePoints.pop()
      }
    },

    changePlacePoints(idx, value) {
      this.$set(this.placePoints[idx], 'place_pts', Number.parseInt(value))
    },

    addPrize() {
      this.prizeFund.push({ place: this.prizeFund.length + 1, prize_data: { type: 'dollars', amount: 0 } })
    },

    deletePrize() {
      if (this.prizeFund.length > 0) {
        this.prizeFund.pop()
      }
    },

    changePrizeAmount(idx, value) {
      this.$set(this.prizeFund[idx].prize_data, 'amount', Number.parseInt(value))
    },

    changePrizeType(idx, value) {
      this.$set(this.prizeFund[idx].prize_data, 'type', value)
    },

    showToast(message, type = 'success') {
      const t = this.$toasted[type](message, {
        action: {
          text: '✕',
          onClick: (e, toastObject) => { toastObject.goAway(0) }
        }
      })
      setTimeout(() => { if (t) t.goAway(0) }, 3000)
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "~@/assets/scss/star.scss";
</style>
